import React, { Component } from 'react';
import Radium from 'radium';

class Button extends Component {

	onClick() {
		if (!this.props.disabled && this.props.onClick) {
			this.props.onClick();
		}
	}

	render() {
		var containerStyles = [this.localStyles().container];

		if (this.props.marginTop) {
			containerStyles.push({
				marginTop: this.props.marginTop
			});
		}

		if (this.props.disabled) {
			containerStyles.push(this.localStyles().containerDisabled);
		}

		if (this.props.width) {
			containerStyles.push({
				width: this.props.width
			});
		}

		return (
			<div style={containerStyles} onClick={() => this.onClick()}>
				<div style={this.localStyles().label}>{this.props.title}</div>
			</div>
		)
	}

	localStyles() {
		return {
			container: {
				backgroundColor: this.props.style.colors.primary,
				height: 50,
				borderRadius: 50,
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "center",
				marginTop: 20,
				marginBottom: 20,
				cursor: "pointer",
				transition: "all 0.5s ease-in-out"
			},
			containerDisabled: {
				opacity: 0.3
			},
			label: {
				color: this.props.style.colors.white,
				fontSize: 18,
				fontWeight: "700"
			}
		}
		
	}
}

export default Radium(Button);


// WEBPACK FOOTER //
// ./src/components/Button.js